export const numTicketConstants = {
  NUMTICKET_REQUEST: 'NUMTICKET_REQUEST',
  NUMTICKET_SUCCESS: 'NUMTICKET_SUCCESS',
  NUMTICKET_ERROR: 'NUMTICKET_ERROR',
};

export const WS_UPDATE_COUNT_EVENT = 'get ticket count';
